import { api } from '@/fsd/shared/api';
import { IInactiveOrganization } from '../model/types/types';

interface IParams {
  single?: boolean;
}

interface IGetInactiveOrganizationsResponse {
  message: string;
  data: IInactiveOrganization[];
}

export const getInactiveOrganizations = async ({
  single = false,
}: IParams): Promise<IGetInactiveOrganizationsResponse> => {
  const data = await api.get<IGetInactiveOrganizationsResponse>(
    `/api/v1/organisation/inactive/organisations/?single=${single}`
  );

  return data;
};
